module.exports = __webpack_public_path__ + "img/logo-cc-2020.4d87d5c6.png";